
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import SEO from 'global/SEO';
import useProtectedRoute from 'hooks/useProtectedRoute';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectors as profileSelectors } from 'lib/entities/profile';
import { effects as chatEffects, selectors } from 'lib/entities/chat/slice';
import {
  subscribeToChatRooms,
  unSubscribeToChatRooms,
} from 'global/WebSocketV2/channels/chatRoom';

const Chat = dynamic(() => import('features/chat'), { ssr: false });

function ChatPage() {
  const { isLoaded } = useProtectedRoute();
  const router = useRouter();
  const { activeRoomId } = useSelector(selectors);
  const dispatch = useDispatch();
  const { data: dataProfile } = useSelector(profileSelectors);

  const { chatid, n }: { chatid?: string | number; n?: string } = router.query;
  const chatId = chatid?.[0] || 0;

  useEffect(() => {
    document
      .getElementById('main-container')
      .classList.add('chat-page-layout-container');

    // store current chat room id
    if (chatId > 0) {
      dispatch(chatEffects.setActiveRoomId(chatId));
    }

    return () => {
      // reset active roomId
      dispatch(chatEffects.resetActiveRoomId());

      if (chatId > 0) {
        // unsubscribe channel last subscribed chat room
        dispatch(unSubscribeToChatRooms([Number(chatId)]));
      }
    };
  }, []);

  useEffect(() => {
    // unsubscribe channel last subscribed chat room
    if (activeRoomId > 0) {
      dispatch(unSubscribeToChatRooms([activeRoomId]));
    }
    if (chatId > 0 && chatId !== activeRoomId) {
      // store current chat room id
      dispatch(chatEffects.setActiveRoomId(chatId));
      // subscribe channel current chat room
      dispatch(subscribeToChatRooms([Number(chatId)]));
    }
  }, [chatId]);

  return (
    <MainLayout maxWidth={1300}>
      <SEO title="Stockbit Chat" customTitle />
      <PageLoader loaded={isLoaded} />
      <Chat
        chatId={chatId}
        username={n}
        currentUserId={parseInt(dataProfile.id, 10)}
      />
    </MainLayout>
  );
}

export default ChatPage;
